import React from 'react'

const WalkthroughBody = ({ children }: { children: React.ReactNode }) => (
  <div className="m-auto my-2 sm:my-6 lg:my-4 space-y-4 sm:space-y-8 lg:space-y-10">{children}</div>
)

export default WalkthroughBody
